<template>
  <div style="height: 100%;background-color: #F0F0F0;" class="index">
    <!-- 资产区域 -->
    <el-container style="" class="index_top">
      <div :class="indexTop1" @click="toNext(1)">
        <div class="index_top_item_head">
          <div>资产</div>
          <div>66666.66</div>
        </div>
        <div class="index_top_item_divider_cow"></div>
        <div class="index_top_item_title">
          <div>资产状态</div>
          <div class="index_top_item_divider_row"></div>
          <div>资产地点</div>
          <div class="index_top_item_divider_row"></div>
          <div>资产类别</div>
        </div>
      </div>

      <div :class="indexTop2" @click="toNext(2)">
        <div class="index_top_item_head">
          <div>待办事项</div>
          <div>60</div>
        </div>
        <div class="index_top_item_divider_cow"></div>
        <div class="index_top_item_title">
          <div>资产清查66</div>
          <div class="index_top_item_divider_row"></div>
          <div>资产使用人变更77</div>
          <div class="index_top_item_divider_row"></div>
          <div>维修申请22</div>
        </div>
      </div>
    </el-container>

    <!-- echart区域 -->
    <el-container class="index_echart">
      <div class="index_echart_item" style="width: 462px;">
        <div class="index_echart_item_top">
          <div class="index_echart_item_top_left">
            <div class="index_echart_item_top_left_cn">设备状态</div>
            <div class="index_echart_item_top_left_en">Secondary text</div>
          </div>
          <div class="index_echart_item_top_right">
            ▼
          </div>
        </div>
        <div class="index_echart_item_bottom">
          <div id="deviceState" style="height: 300px; width: 400px;"></div>
        </div>
      </div>

      <div class="index_echart_item" style="width: 710px;">
        <div class="index_echart_item_top">
          <div class="index_echart_item_top_left">
            <div class="index_echart_item_top_left_cn">设备分类统计</div>
            <div class="index_echart_item_top_left_en">Secondary text</div>
          </div>
          <div class="index_echart_item_top_right">
            ▼
          </div>
        </div>
        <div class="index_echart_item_bottom">
          <div id="device_class" style="height: 300px; width: 710px;"></div>
        </div>
      </div>

      <div class="index_echart_item" style="width: 462px;">
        <div class="index_echart_item_top">
          <div class="index_echart_item_top_left">
            <div class="index_echart_item_top_left_cn">部门使用占比</div>
            <div class="index_echart_item_top_left_en">Secondary text</div>
          </div>
          <div class="index_echart_item_top_right">
            ▼
          </div>
        </div>
        <div class="index_echart_item_bottom">
          <div id="department_use" style="height: 300px; width: 440px;"></div>
        </div>
      </div>
    </el-container>

    <!-- 表格区域 -->
    <div>
      <el-table
        :data="tableData"
        style="width: 100%">
        <el-table-column
          prop=""
          label="资产名称"
          width="">
        </el-table-column>
        <el-table-column
          prop=""
          label="固定资产编码"
          width="">
        </el-table-column>
        <el-table-column
          prop=""
          label="资产状态">
        </el-table-column>
        <el-table-column
          prop=""
          label="存放地点">
        </el-table-column>
        <el-table-column
          prop=""
          label="资产类别ID">
        </el-table-column>
        <el-table-column
          prop=""
          label="资产RFID">
        </el-table-column>
        <el-table-column
          prop=""
          label="管理部门">
        </el-table-column>
        <el-table-column
          prop=""
          label="操作">
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
  import echarts from 'echarts'
  export default {
    name: 'YIndex',
    data () {
      return {
        indexTop1: 'index_top_item',
        indexTop2: 'index_top_item1',
      }
    },
    mounted() {
		
			
		// 几个饼图和柱状图在页面开始就预加载出来
      this.showDeviceStateData()
      this.showDeviceClassData()
      this.showDepartmentUseData()
      // this.showSecordPieData();
      // this.showFourPieData();
      // this.showThreePieData();
     },
	watch: {
	   $route(to, from) {
	       window.location.reload(); //监测到路由发生跳转时刷新一次页面
	   },
	},
    methods: {
      toNext(i) {
        // i == 1 ? this.indexTop1 = 'index_top_item1'  : this.indexTop1 = 'index_top_item'
        // i == 2 ? this.indexTop2 = 'index_top_item'  : this.indexTop2 = 'index_top_item1'
        if(i == 1) {
          this.indexTop1 = 'index_top_item1'
          this.indexTop2 = 'index_top_item'
        } 
        if(i == 2) {
          this.indexTop1 = 'index_top_item'
          this.indexTop2 = 'index_top_item1'
        } 
      },

      showDeviceStateData(){
        let myChart = echarts.init(document.getElementById('deviceState'));
        let option = {
          // title: {
          //   text: 'Referer of a Website',
          //   subtext: 'Fake Data',
          //   left: 'center'
          // },
          tooltip: {
            trigger: 'item'
          },
          legend: {
            orient: 'vertical',
            right:'right'
          },
          series: [
            {
              name: '资产信息',
              type: 'pie',
              radius: '50%',
              data: [
                { value: 1048, name: '在用' },
                { value: 735, name: '备用' },
                { value: 580, name: '在修' },
                { value: 484, name: '待修' },
                { value: 300, name: '闲置' }
              ],
              // color: ['#8DB7FE', '#A7FFEF', '#6FCF97', '#EF4A4A', '#F2C94C'],
              color: ['rgba(141, 183, 254, 1)', 'rgba(167, 255, 239, 1)', 'rgba(111, 207, 151, 1)', 'rgba(239, 74, 74, 1)', 'rgba(242, 201, 76, 1)'],
              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
              }
            }
          ]
        }
        myChart.setOption(option);
      },

      showDeviceClassData(){
        let myChart = echarts.init(document.getElementById('device_class'));
        let option = {
          // color: ,
          tooltip: {
            trigger: 'item'
          },
          xAxis: {
            type: 'category',
            data: ['设备a', '设备b', '设备c', '设备d', '设备e', '设备f', '设备g']
          },
          yAxis: {
            type: 'value'
          },
          series: [
            {
              name: '资产类型',
              data: [120, 600, 150, 80, 70, 110, 130],
              type: 'bar',
              itemStyle: {
                normal: {
                    //这里是颜色
                    color: function(params) {
                        //注意，如果颜色太少的话，后面颜色不会自动循环，最好多定义几个颜色
                        var colorList = ['rgba(3, 100, 255, 0.60)', 'rgba(255, 120, 36, 0.60)', 'rgba(141, 48, 255, 0.60)', 'rgba(171, 159, 25, 0.60)', 'rgba(106, 242, 235, 0.60)', 'rgba(42, 209, 173, 0.60)', 'rgba(204, 79, 104, 0.60)']
                        return colorList[params.dataIndex]
                    }
                }
              }
            }
          ],
          
        }
        myChart.setOption(option);
      },
      
      showDepartmentUseData(){
        let myChart = echarts.init(document.getElementById('department_use'));
        let option = {
          // title: {
          //   text: 'Referer of a Website',
          //   subtext: 'Fake Data',
          //   left: 'center'
          // },
          tooltip: {
            trigger: 'item'
          },
          legend: {
            orient: 'vertical',
            right:'right'
          },
          series: [
            {
              name: '部门使用占比',
              type: 'pie',
              radius: '50%',
              data: [
                { value: 1048, name: '市场部' },
                { value: 735, name: '采购部' },
                { value: 580, name: '研发部' },
                { value: 484, name: '财务部' },
                { value: 300, name: '其他' }
              ],
              color: ['#8DB7FE', '#A7FFEF', '#6FCF97', '#EF4A4A', '#F2C94C'],
              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
              }
            }
          ]
        }
        myChart.setOption(option);
      },
    }
  }
</script>

<style lang="less">
  .index {

    .index_top {
      display: flex;
      justify-content: space-between;

      .index_top_item {
        width: 825px;
        background: #ffffff;
        // margin-right: 40px;

        .index_top_item_head {
          margin: 0 40px;
          height: 60px;
          line-height: 60px;
          display: flex;
          justify-content: space-between;
          color: #000000;
          font-size: 24px;
          font-weight: Medium;
          
        }
        .index_top_item_divider_cow {
          width: 760px;
          margin: 0 20px;
          height: 2px;
          background: linear-gradient(#ffffff, #F5F5F5);
        }
        .index_top_item_divider_row {
          width: 2px;
          height: 60px;
          margin: 20px 0;
          background: linear-gradient(#ffffff, #F5F5F5);
        }
        .index_top_item_title {
          display: flex;
          justify-content: space-around;
          height: 100px;
          line-height: 100px;
          font-size: 24px;
          color: #687682;
        }
      }

      .index_top_item1 {
        width: 825px;
        background: #4285F4;
        // margin-right: 40px;

        .index_top_item_head {
          margin: 0 40px;
          height: 60px;
          line-height: 60px;
          display: flex;
          justify-content: space-between;
          color: #ffffff;
          font-size: 24px;
          font-weight: Medium;
          
        }
        .index_top_item_divider_cow {
          width: 760px;
          margin: 0 20px;
          height: 2px;
          background: linear-gradient(#ffffff, #F5F5F5);
        }
        .index_top_item_divider_row {
          width: 2px;
          height: 60px;
          margin: 20px 0;
          background: linear-gradient(#ffffff, #F5F5F5);
        }
        .index_top_item_title {
          display: flex;
          justify-content: space-around;
          height: 100px;
          line-height: 100px;
          font-size: 24px;
          color: #ffffff;
        }
      }

    }
  
    .index_echart {
      height: 400px;
      margin: 12px 0;
      display: flex;
      justify-content: space-between;
      // background: #ffffff;

      .index_echart_item {
        // margin: 10px 0 0 0;
        display: flex;
        flex-direction: column;
        background: #ffffff;

        .index_echart_item_top {
          height: 120px;
          border-bottom: 1px #ECECEC solid;
          display: flex;
          justify-content: space-between;

          .index_echart_item_top_left {
            margin-left: 50px;
            display: flex;
            flex-direction: column;
            text-align: left;
            
            .index_echart_item_top_left_cn {
              color: #0B1354;
              font-size: 36px;
              margin-top: 15px;
              font-weight: 800;
            }
            .index_echart_item_top_left_en {
              color: #4F4F4F;
              font-size: 14px;
              margin: 5px 0;
            }
          }
          .index_echart_item_top_right {
            margin-right: 50px;
            color: #A5ACB1;
            font-size: 24px;
            margin-top: 44px;
          }
        }

        .index_echart_item_bottom {

        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/YIndex.vue